
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateShopBankCard, QueryBankCodeList } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'
import constan from '@/utils/constant'
import { VImageUpload } from '@/components/upload'

@Component({
  components: {VImageUpload},
})
export default class EditBankCodeDialog extends Vue {
  private show = false
  private data: any ={
    bankType: 1,
    bankCode: undefined,
    bankName: undefined,
    accountName: '',
    accountNo: ''
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    bankCode: [this.requiredRule],
    accountName: [this.requiredRule],
    accountNo: [this.requiredRule],
    bankType: [this.requiredRule],
  }
  private type = 'add'
  // 银行列表
  private bankList: any[] = []


  private get isPreview() {
    if (this.type == 'preview') {
      return true
    }
    return false
  }

  @Emit('close')
  private close() {
    (this.$refs.form as ElForm).resetFields()
    this.show = false
  }

  public created() {
    // 加载银行卡列表
    QueryBankCodeList({}).then(res => {
      this.bankList = res.list
    })
  }

  public async open() {
    this.show = true
    this.data = {
      bankType: 1,
      bankCode: undefined,
      bankName: undefined,
      accountName: '',
      accountNo: ''
    }

  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      CreateShopBankCard(this.data).then(res=>{
        if(res){
          Message.success('添加成功')
          this.close()
        }
      })

    })
  }

  private bankChange() {
    const res = this.bankList.filter(e => e.bankCode == this.data.bankCode)
    if (res.length > 0) {
      this.data.bankName = res[0].bankName
    } else {
      this.data.bankName = ""
    }
  }
}
